/**
 * @classdesc Finnish Language Pack
 * @desc This class will used to translate tokens into the Finnish language.
 * @namespace Languages.Finnish
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Finnish
 */
export const dictionary = {
	'years'   : 'Vuotta',
	'months'  : 'Kuukautta',
	'days'    : 'Päivää',
	'hours'   : 'Tuntia',
	'minutes' : 'Minuuttia',
	'seconds' : 'Sekuntia'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Finnish
 */
export const aliases = ['fi', 'fi-fi', 'finnish'];
